import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities } from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const TYPES = {
  READ_ONBOARDING_REQUEST: 'COGNITO_FORM_ANSWER/READ_ONBOARDING_REQUEST',
  READ_ONBOARDING_SUCCESS: 'COGNITO_FORM_ANSWER/READ_ONBOARDING_SUCCESS',
  READ_ONBOARDING_FAILURE: 'COGNITO_FORM_ANSWER/READ_ONBOARDING_FAILURE',
  CHECK_ONBOARDING_ANSWER_REQUEST:
    'COGNITO_FORM_ANSWER/CHECK_ONBOARDING_ANSWER_REQUEST',
  CHECK_ONBOARDING_ANSWER_SUCCESS:
    'COGNITO_FORM_ANSWER/CHECK_ONBOARDING_ANSWER_SUCCESS',
  CHECK_ONBOARDING_ANSWER_FAILURE:
    'COGNITO_FORM_ANSWER/CHECK_ONBOARDING_ANSWER_FAILURE',
  CREATE_COGNITO_FORM_SKIP_REQUEST:
    'COGNITO_FORM_ANSWER/CREATE_COGNITO_FORM_SKIP_REQUEST',
  CREATE_COGNITO_FORM_SKIP_SUCCESS:
    'COGNITO_FORM_ANSWER/CREATE_COGNITO_FORM_SKIP_SUCCESS',
  CREATE_COGNITO_FORM_SKIP_FAILURE:
    'COGNITO_FORM_ANSWER/CREATE_COGNITO_FORM_SKIP_FAILURE',
  LIST_REQUEST: 'COGNITO_FORM_ANSWER/LIST_REQUEST',
  LIST_SUCCESS: 'COGNITO_FORM_ANSWER/LIST_SUCCESS',
  LIST_FAILURE: 'COGNITO_FORM_ANSWER/LIST_FAILURE',
  DELETE_REQUEST: 'COGNITO_FORM_ANSWER/DELETE_REQUEST',
  DELETE_SUCCESS: 'COGNITO_FORM_ANSWER/DELETE_SUCCESS',
  DELETE_FAILURE: 'COGNITO_FORM_ANSWER/DELETE_FAILURE',
  PDF_REQUEST: 'COGNITO_FORM_ANSWER/PDF_REQUEST',
  PDF_SUCCESS: 'COGNITO_FORM_ANSWER/PDF_SUCCESS',
  PDF_FAILURE: 'COGNITO_FORM_ANSWER/PDF_FAILURE',
};
// ACTION CREATORS

export function cognitoFormAnswerOnboardingReadRequest(
  partnershipId,
  careGuideId
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerOnboardingReadRequest(${partnershipId}, ${careGuideId})`
  );
  return {
    type: TYPES.READ_ONBOARDING_REQUEST,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
  };
}

export function cognitoFormAnswerOnboardingReadSuccess(
  partnershipId,
  careGuideId,
  data
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerOnboardingReadSuccess(${partnershipId}, ${careGuideId}, %j)`,
    data
  );
  return {
    type: TYPES.READ_ONBOARDING_SUCCESS,
    id: data.id,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAnswerOnboardingReadFailure(
  partnershipId,
  careGuideId,
  error
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerOnboardingReadFailure(${partnershipId}, ${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.READ_ONBOARDING_FAILURE,
    error: error,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
  };
}

export function checkOnboardingAnswerReadRequest(partnershipId, careGuideId) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] checkOnboardingAnswerReadRequest(${partnershipId}, ${careGuideId})`
  );
  return {
    type: TYPES.CHECK_ONBOARDING_ANSWER_REQUEST,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
  };
}

export function checkOnboardingAnswerReadSuccess(partnershipId, careGuideId) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] checkOnboardingAnswerReadSuccess(${partnershipId}, ${careGuideId})`
  );
  return {
    type: TYPES.CHECK_ONBOARDING_ANSWER_SUCCESS,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function checkOnboardingAnswerReadFailure(
  partnershipId,
  careGuideId,
  error
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] checkOnboardingAnswerReadFailure(${partnershipId}, ${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.CHECK_ONBOARDING_ANSWER_FAILURE,
    error: error,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
  };
}

export function cognitoFormSkipCreateRequest(careGuideId, data) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormSkipCreateRequest(${careGuideId}, %j)`,
    data
  );
  return {
    type: TYPES.CREATE_COGNITO_FORM_SKIP_REQUEST,
    careGuideId: careGuideId,
  };
}

export function cognitoFormSkipCreateSuccess(careGuideId, data) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormSkipCreateSuccess(${careGuideId}, %j)`,
    data
  );
  return {
    type: TYPES.CREATE_COGNITO_FORM_SKIP_SUCCESS,
    careGuideId: careGuideId,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormSkipCreateFailure(careGuideId, error) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormSkipCreateFailure(${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.CREATE_COGNITO_FORM_SKIP_FAILURE,
    careGuideId: careGuideId,
    error: error,
  };
}

export function cognitoFormAnswerListRequest(
  partnershipId,
  careGuideId,
  cognitoFormId,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerListRequest(${partnershipId}, ${careGuideId}, ${cognitoFormId}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.LIST_REQUEST,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    cognitoFormId: cognitoFormId,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function cognitoFormAnswerListSuccess(
  partnershipId,
  careGuideId,
  cognitoFormId,
  data
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerListSuccess(%j)`,
    data
  );

  return {
    type: TYPES.LIST_SUCCESS,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    cognitoFormId: cognitoFormId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAnswerListFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerListFailure(%j)`,
    error
  );
  return {
    type: TYPES.LIST_FAILURE,
    error: error,
  };
}

export function cognitoFormAnswerPDFRequest(partnershipId, careGuideId, id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerPDFRequest(${id}, ${partnershipId}, ${careGuideId})`
  );
  return {
    type: TYPES.PDF_REQUEST,
    id: id,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
  };
}

export function cognitoFormAnswerPDFSuccess(partnershipId, careGuideId, id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerPDFSuccess(${id}, ${partnershipId}, ${careGuideId})`
  );
  return {
    type: TYPES.PDF_SUCCESS,
    id: id,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAnswerPDFFailure(
  partnershipId,
  careGuideId,
  id,
  error
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerPDFFailure(${id}, ${partnershipId}, ${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.PDF_FAILURE,
    id: id,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    error: error,
  };
}

export function cognitoFormAnswerDeleteRequest(partnershipId, careGuideId, id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerDeleteRequest(${partnershipId}, ${careGuideId}, ${id})`
  );
  return {
    type: TYPES.DELETE_REQUEST,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    id: id,
  };
}

export function cognitoFormAnswerDeleteSuccess(partnershipId, careGuideId, id) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerDeleteSuccess(${partnershipId}, ${careGuideId}, ${id})`
  );
  return {
    type: TYPES.DELETE_SUCCESS,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    id: id,
  };
}

export function cognitoFormAnswerDeleteFailure(
  partnershipId,
  careGuideId,
  error
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] cognitoFormAnswerDeleteFailure(${partnershipId}, ${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.DELETE_FAILURE,
    partnershipId: partnershipId,
    careGuideId: careGuideId,
    error: error,
  };
}

export function loadCognitoFormAnswerOnboarding(
  partnershipId,
  careGuideId,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] loadCognitoFormAnswerOnboarding(${partnershipId}, ${careGuideId}, ###)`
  );

  return async function (dispatch) {
    dispatch(
      cognitoFormAnswerOnboardingReadRequest(partnershipId, careGuideId)
    );

    // call API
    const response = await api.getCognitoFormAnswerOnboarding(
      partnershipId,
      careGuideId
    );
    let success = false;

    // get cognito Form Answer Onboarding success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognitoFormAnswer success. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form_answer'])],
        [schema.cognitoFormAnswer]
      );

      const data = {
        id: response.getIn(['data', 'cognito_form_answer', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(
        cognitoFormAnswerOnboardingReadSuccess(partnershipId, careGuideId, data)
      );
      success = true;

      // get cognito Form Answer Onboarding failure
    } else {
      Logger.log(
        'info',
        `Get API cognitoFormAnswer failure. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId},`
      );
      dispatch(
        cognitoFormAnswerOnboardingReadFailure(
          partnershipId,
          careGuideId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function checkOnboardingAnswer(
  partnershipId,
  careGuideId,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] checkOnboardingAnswer(${partnershipId}, ${careGuideId}, ###)`
  );

  return async function (dispatch) {
    dispatch(checkOnboardingAnswerReadRequest(partnershipId, careGuideId));

    // call API
    const response = await api.getCheckOnboardingAnswer(
      partnershipId,
      careGuideId
    );
    let success = false;
    let cognitoFormId = null;
    let cognitoFormKey = null;
    let newUserRequirement = null;
    let oldUserRequirement = null;
    let isOldUser = false;
    let id = null;

    // get check onboarding answer success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API checkOnboardingAnswer success. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}.`
      );
      const normalizedEntities = normalize(
        response.getIn(['data', 'care_guide']),
        [schema.careGuide]
      );

      cognitoFormId = response.getIn([
        'data',
        'registration_code',
        'cognito_forms',
        'form_id',
      ]);
      cognitoFormKey = response.getIn([
        'data',
        'registration_code',
        'cognito_forms',
        'form_key',
      ]);
      newUserRequirement = response.getIn([
        'data',
        'registration_code',
        'cognito_forms',
        'new_user_requirement',
      ]);
      oldUserRequirement = response.getIn([
        'data',
        'registration_code',
        'cognito_forms',
        'old_user_requirement',
      ]);
      id = response.getIn(['data', 'registration_code', 'cognito_forms', 'id']);
      isOldUser = response.getIn(['data', 'is_old_user']);
      dispatch(addEntities(normalizedEntities));
      dispatch(checkOnboardingAnswerReadSuccess(partnershipId, careGuideId));
      success = true;
    } else if (204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API checkOnboardingAnswer success. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}.`
      );

      success = true;
    } else {
      // get check onboarding answer failure
      Logger.log(
        'info',
        `Get API checkOnboardingAnswer failure. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId},`
      );
      dispatch(
        checkOnboardingAnswerReadFailure(
          partnershipId,
          careGuideId,
          response.getIn(['data', 'error'])
        )
      );
    }
    // callback function
    cb(
      success,
      cognitoFormId,
      cognitoFormKey,
      newUserRequirement,
      oldUserRequirement,
      isOldUser,
      id
    );
  };
}

export function createCognitoFormSkip(careGuideId, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] createCognitoFormSkip(${careGuideId}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(cognitoFormSkipCreateRequest(careGuideId, data));

    // call API
    const response = await api.postCareGuideCognitoFormSkip(careGuideId, data);
    let success = false;

    // post cognito form skip success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API cognito form skip success. Care Guide ID: ${careGuideId}.`
      );

      const data = {
        id: response.getIn(['data', 'calendar_event', 'id']),
      };

      dispatch(cognitoFormSkipCreateSuccess(careGuideId, data));
      success = true;

      // post cognito form skip failure
    } else {
      Logger.log(
        'info',
        `POST API cognito form skip failure. Care Guide ID: ${careGuideId}.`
      );
      dispatch(
        cognitoFormSkipCreateFailure(
          careGuideId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

// API THUNK ACTION CREATORS
export function loadCognitoFormAnswers(
  partnershipId = null,
  careGuideId = null,
  cognitoFormId = null,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] loadCognitoFormAnswers(${partnershipId}, ${careGuideId}, ${cognitoFormId}, ${page}, ${limit}, ${order}, ###)`
  );

  return async function (dispatch) {
    dispatch(
      cognitoFormAnswerListRequest(
        partnershipId,
        careGuideId,
        cognitoFormId,
        page,
        limit,
        order,
        filter
      )
    );

    // call API
    const response = await api.getCognitoFormAnswers(
      partnershipId,
      careGuideId,
      cognitoFormId,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get cognito form answers list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito form answers list success. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}, Cognito Form ID: ${cognitoFormId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'cognito_form_answers']).map((formAnswer) => {
          const answersAsArray = formAnswer.answers.map(([key, value]) => ({
            key,
            value,
          }));
          return { ...formAnswer, answers: answersAsArray };
        }),
        [schema.cognitoFormAnswer]
      );

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(
        cognitoFormAnswerListSuccess(
          partnershipId,
          careGuideId,
          cognitoFormId,
          data
        )
      );
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito form answers list success [empty]. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}, Cognito Form ID: ${cognitoFormId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(
        cognitoFormAnswerListSuccess(
          partnershipId,
          careGuideId,
          cognitoFormId,
          data
        )
      );

      // get cognito form answers list failure
    } else {
      Logger.log(
        'info',
        `Get API cognito form answers list failure. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}, Cognito Form ID: ${cognitoFormId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(cognitoFormAnswerListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function generateCognitoFormAnswerPDF(
  partnershipId = null,
  careGuideId = null,
  id = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] generateCognitoFormAnswerPDF(${partnershipId}, ${careGuideId}, ${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAnswerPDFRequest(partnershipId, careGuideId, id));

    // call API
    const response = await api.getCognitoFormAnswerPDF(
      partnershipId,
      careGuideId,
      id
    );
    let success = false;

    // get cognito form answer PDF success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito form answer PDF success. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId} ID: ${id}.`
      );

      // trigger browser download
      const url = window.URL.createObjectURL(
        new Blob([response.get('data')], { type: 'application/pdf' })
      );
      const link = document.createElement('a');
      link.href = url;
      const contentDisposition = response.get('headers')['content-disposition'];
      link.setAttribute(
        'download',
        contentDisposition
          ? contentDisposition.substring(
              contentDisposition.indexOf('"') + 1,
              contentDisposition.lastIndexOf('"')
            )
          : 'partnership-form-answer.pdf'
      );
      document.body.appendChild(link);
      link.click();

      dispatch(cognitoFormAnswerPDFSuccess(partnershipId, careGuideId, id));
      success = true;

      // get cognito form answer PDF failure
    } else {
      Logger.log(
        'info',
        `Get API cognito form answer PDF failure.  Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId} ID: ${id}.`
      );
      dispatch(
        cognitoFormAnswerPDFFailure(
          partnershipId,
          careGuideId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function deleteCognitoFormAnswer(
  partnershipId = null,
  careGuideId = null,
  id = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.actions] deleteCognitoFormAnswer(${partnershipId}, ${careGuideId}, ${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAnswerDeleteRequest(partnershipId, careGuideId, id));

    // call API
    const response = await api.deleteCognitoFormAnswer(
      partnershipId,
      careGuideId,
      id
    );
    let success = false;

    // delete cognito form answer success
    if (204 === response.get('status')) {
      Logger.log(
        'info',
        `Delete API cognito form answer success. Partnership ID: ${partnershipId}, Care Guide ID: ${careGuideId}, ID: ${id}.`
      );
      dispatch(cognitoFormAnswerDeleteSuccess(partnershipId, careGuideId, id));
      success = true;

      // get cognito form answer failure
    } else {
      Logger.log(
        'info',
        `Delete API cognito form answer failure. Partnership ID: ${partnershipId} Care Guide ID: ${careGuideId}  ID: ${id}.`
      );
      dispatch(
        cognitoFormAnswerDeleteFailure(
          partnershipId,
          careGuideId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

Logger.log('silly', `state.cognitoFormAnswers.actions loaded.`);
